/**
 * @file 定义Progress的数据接口
 * @author liuhanwei
 */
;
;
export {};
